import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Modal from 'react-responsive-modal'
import Profile from '../../containers/Profile'
import style from './style'

/**
 * A profile icon and menu
 */

class ProfileMenu extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isShowProfile: false
    }
    this.showProfile = this.showProfile.bind(this)
  }

  showProfile () {
    this.setState(prevState => {
      return {
        isShowProfile: !prevState.isShowProfile
      }
    })
  }

  render () {
    const { props, state } = this
    const { classes, icon, fullName, onLogoutClick } = props
    const {
      base,
      hideOnMobile,
      content,
      iconContainer,
      iconText,
      iconImg
    } = classes
    const { isActive } = state

    const className = isActive ? `${base}` : `${base} ${hideOnMobile}`

    return (
      <div className={className}>
        <div className={content}>
          <div className={iconContainer}>
            <span className={iconText} onClick={this.showProfile}>
              {fullName}{' '}
              {icon && (
                <span className={iconImg}>
                  <img src={icon.src} />
                </span>
              )}
            </span>

            <span className={iconText} onClick={onLogoutClick}>
              Logout
            </span>
          </div>
          <Modal
            classNames={{
              modal: 'feedback-modal profile-modal',
              overlay: 'feedback-overlay',
              closeButton: 'modal-close-btn'
            }}
            open={this.state.isShowProfile}
            center
            showCloseIcon={true}
            animationDuration={100}
            onClose={this.showProfile}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            closeIconSvgPath={
              <path
                strokeLinecap="round"
                stroke="black"
                strokeWidth="2"
                d="M 10,10 L 30,30 M 30,10 L 10,30"
              />
            }
          >
            <div className="modal-content profile-modal-content">
              <Profile onSubmit={this.showProfile} />
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}

const styleAndTheme = () => style

export default injectSheet(styleAndTheme)(ProfileMenu)
